// src/components/footer/footer.component.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import './footer.styles.scss';

const Footer = () => {
  const whatsappLink = "https://wa.me/923224314712";
  const email = "crispyhairsolutionpvtltd@gmail.com";
  const instagramLink = "https://www.instagram.com/crispyhair.solution/";
  const facebookLink = "https://www.facebook.com/CrispyHairSolution/";
  const youtubeChannel = "https://www.youtube.com/@crispyhairsolutionpvtltd2064";
  const mapLink = "https://maps.app.goo.gl/srh739P8w5n1uCMw5";

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h3>Crispy Hair <span>Solution</span></h3>
          <p className="footer-description">
            Premium human hair wigs, hair patches, hair units, and hair extensions 
            in Pakistan and Saudi Arabia. Serving in pk Rawalpindi, Islamabad, Lahore, Karachi 
          </p>
          <div className="footer-social">
            <a href={facebookLink} target="_blank" rel="noopener noreferrer">📘</a>
            <a href={instagramLink} target="_blank" rel="noopener noreferrer">📸</a>
            <a href={youtubeChannel} target="_blank" rel="noopener noreferrer">▶️</a>
            <a href={whatsappLink} target="_blank" rel="noopener noreferrer">💬</a>
          </div>
        </div>

        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/men-wigs">Men Wigs</Link></li>
            <li><Link to="/lady-hair">Lady Hair</Link></li>
            <li><Link to="/new-arrivals">New Arrivals</Link></li>
            <li><Link to="/hair-transplant">Hair Transplant</Link></li>
            <li><Link to="/hair-centers">Hair Centers</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Contact</h4>
          <div className="footer-contact">
            <p>📞 <a href={whatsappLink} target="_blank" rel="noopener noreferrer">+923224314712</a></p>
            <p>📧 <a href={`mailto:${email}`}>{email}</a></p>
            <p>📍 Asim Plaza, 1st Floor, Office 24 Chandni chowk Rawalpindi Pakistan </p>
            <p>📍 Saudi Arabia All cities (Only Dilvery )0531802864</p>
            <a href={mapLink} target="_blank" rel="noopener noreferrer" className="map-link">
              View on Google Maps →
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Crispy Hair Solution Pvt Ltd. All rights reserved.</p>
        <p>Own by Pakistan</p>
      </div>
    </footer>
  );
};

export default Footer;